document.addEventListener('DOMContentLoaded', function() {
    let announcementText = document.querySelectorAll('.announcemnet-bar-custom .slider-annoument-content');

    announcementText.forEach(function(item) {
        //tomar data-key hacerle un split cortando por ","
        let words = item.getAttribute('data-key').split(',');
        let color = item.getAttribute('data-color');
    
        // recorrer el array de palabras y buscar las palabras en el texto p dentro de slider-annoument-content
        words.forEach(function(word) {
            // Escapar caracteres especiales en la palabra
            let escapedWord = word.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
            let regex = new RegExp(escapedWord, 'g');
            item.innerHTML = item.innerHTML.replace(regex, `<span style="color:${ color }">${ word }</span>`);
        });
    });
});
